<div class="container">
  <img class="wguLogo" src="assets/images/wgu-logo-white.svg" alt="WGU logo">
  <span class="headerLink" *ngIf="showDashboardMenu()" [ngClass]="{'active': currentUrl.includes('/dashboard')}" (click)="navigate('dashboard')" onkeydown="navigate('dashboard')">
    <mat-icon class="linkIcon">dashboard</mat-icon>
    Dashboard
  </span>
  <span class="headerLink active" *ngIf="showDashboardMenu()" [ngClass]="{'active': currentUrl.includes('/upload')}" (click)="navigate('upload')" onkeydown="navigate('upload')">
    <mat-icon class="linkIcon">upload</mat-icon>
    Upload
  </span>
  <span class="username">
    <mat-icon class="linkIcon">account_circle</mat-icon>
    {{username}}
  </span>
</div>